import React, { useRef, useState } from 'react';
import {Link} from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const PriceList = () => {
    const { t } = useTranslation();
    const [activePrice, setActivePrice] = useState(1)

    const priceBlock = [
        {
            srid:2,
            title: t('priceList.keyHolding'),
            price:'15',
            period: 'month',
            description: t('priceList.keyHoldingDesc'),
            features: t('priceList.keyHoldingFeatures', { returnObjects: true }) as string[],
            popular: false
        },
        {
            srid:1,
            title: t('priceList.propertyManagement'),
            price:'85',
            period: 'service',
            description: t('priceList.propertyManagementDesc'),
            features: t('priceList.propertyManagementFeatures', { returnObjects: true }) as string[],
            popular: true
        },
        {
            srid:3,
            title: t('priceList.cleaningService'),
            price:'50',
            period: 'service',
            description: t('priceList.cleaningServiceDesc'),
            features: t('priceList.cleaningServiceFeatures', { returnObjects: true }) as string[],
            popular: false
        },
        {
            srid:4,
            title: t('priceList.laundryService'),
            price:'15',
            period: 'service',
            description: t('priceList.laundryServiceDesc'),
            features: t('priceList.laundryServiceFeatures', { returnObjects: true }) as string[],
            popular: false
        },
    ];

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="center-title">
                        <span className="sub-title" id="pricing">{t('priceList.subtitle')}</span>
                        <h2 className="h2-title">{t('priceList.title')}</h2>
                        <p>{t('priceList.startingFrom')}</p>
                    </div>

                </div>
            </div>
            <div className="pricing-list">
                <div className="row pricing-slider">
                    {priceBlock.map((item, ind)=>(
                        <div className="col-lg-3 col-md-6 col-sm-6 col-12" key={ind}>
                            <div className={`pricing-box ${activePrice === item.srid ? 'active' : ''} ${item.popular ? 'popular-plan' : ''}`}
                                onMouseEnter={()=>setActivePrice(item.srid)}
                            >
                                {item.popular && <div className="popular-badge">{t('priceList.mostPopular')}</div>}
                                <div className="pricing-box-text">
                                    <h3 className="h3-title">{item.title}</h3>
                                    <h5 className="price-rate">
                                        <span>€{item.price}</span>/{item.period}
                                    </h5>
                                    <p>{item.description}</p>
                                    <ul>
                                        {item.features.map((feature, i) => (
                                            <li key={i}>{feature}</li>
                                        ))}
                                    </ul>
                                </div>
                                <Link to={"/contact"} className="sec-btn"><span>{t('priceList.getStarted')}</span></Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default PriceList;